import {
  RESET_IN_CART,
  ADD_ROOM_IN_CART,
  REMOVE_ROOM_IN_CART,
  UPDATE_UPSALE_IN_CART,
  UPDATE_ROOM_PRICE_IN_CART,
  SET_VOUCHER,
  SET_TAX,
  SET_ROOMS_IN_CART,
} from "./types";

export const resetCart = (item = null) => {
  return {
    type: RESET_IN_CART,
    payload: item,
  };
};

export const addRoomItem = (item) => {
  return {
    type: ADD_ROOM_IN_CART,
    payload: item,
  };
};

export const removeRoomItem = (item) => {
  return {
    type: REMOVE_ROOM_IN_CART,
    payload: item,
  };
};

export const updateRoomPrice = (item) => {
  return {
    type: UPDATE_ROOM_PRICE_IN_CART,
    payload: item,
  };
};

// Replaces the rooms of the cart, e.g. with the apartment selected automatically.
export const setCartRooms = (rooms) => {
  return {
    type: SET_ROOMS_IN_CART,
    payload: rooms,
  };
};

export const updateUpsellItem = (item) => {
  return {
    type: UPDATE_UPSALE_IN_CART,
    payload: item,
  };
};
export const set_voucher = (voucher) => {
  return {
    type: SET_VOUCHER,
    payload: voucher,
  };
};

export const set_tax = (tax) => {
  return {
    type: SET_TAX,
    payload: tax,
  };
};
